import { render, staticRenderFns } from "./Punti.vue?vue&type=template&id=7e54f618&scoped=true&"
import script from "./Punti.vue?vue&type=script&lang=js&"
export * from "./Punti.vue?vue&type=script&lang=js&"
import style0 from "./Punti.vue?vue&type=style&index=0&id=7e54f618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54f618",
  null
  
)

export default component.exports